module.exports = __webpack_public_path__ + "img/cta_4.4222771d.png";